import React from "react";
import { PdfFromGridProps } from "../components/PdfFromGrid";
import { useNavigate } from "react-router-dom";

export default function useNavigateToPdf() {
  const navigate = useNavigate();
  
  return {
    navigateToPdf: ({data, title} : PdfFromGridProps) => {
      navigate("/ver/pdf", { state: { data, title } });
    },
  };
}
